"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeedShuffle = void 0;
var SeedShuffle;
(function (SeedShuffle) {
    function shuffle(arr, seedStr) {
        const seed = getSeed(seedStr);
        if (!seed)
            return arr;
        const shuff = arr.slice(0);
        const size = shuff.length;
        const map = genMap(size, seed);
        for (let i = size - 1; i > 0; i--) {
            shuff[i] = shuff.splice(map[size - 1 - i], 1, shuff[i])[0];
        }
        return shuff;
    }
    SeedShuffle.shuffle = shuffle;
    function unshuffle(arr, seedStr) {
        const seed = getSeed(seedStr);
        if (!seed)
            return arr;
        const shuff = arr.slice(0);
        const size = shuff.length;
        const map = genMap(size, seed);
        for (let i = 1; i < size; i++) {
            shuff[i] = shuff.splice(map[size - 1 - i], 1, shuff[i])[0];
        }
        return shuff;
    }
    SeedShuffle.unshuffle = unshuffle;
    function genMap(size, seed) {
        const map = new Array(size);
        for (let x = 0; x < size; x++) {
            //Don't change these numbers.
            map[x] = (((seed = (seed * 9301 + 49297) % 233280) / 233280.0) * size) | 0;
        }
        return map;
    }
    function getSeed(seedStr) {
        if (isNaN(Number(seedStr))) {
            return Number(String(seedStr)
                .split('')
                .map(function (x) {
                return x.charCodeAt(0);
            })
                .join(''));
        }
        return Number(seedStr);
    }
})(SeedShuffle || (exports.SeedShuffle = SeedShuffle = {}));
//# sourceMappingURL=SeedShuffle.js.map